<template>
	<grid>
		<grid-group v-for="group in devicesGroups" :key="group.id" :title=" group.name">
			<template v-slot:options>
				<action-group>
					<action-group-item-button @click="editGroup(group.id)" :title="$t('Edit group')" />
					<action-group-item-button @click="onDeleteGroup(group.id)" :title="$t('Delete group')" :danger="true" />
				</action-group>
			</template>
			<grid-item v-for="device in devicesByGroup(group)" :key="device.id" :title="$t('Name')" :value="device.name" :avatar="true">
				<action-group>
					<action-group-item-button @click="goToPatient(device)" :title="$t('Go to paticient')" />
					<action-group-item-button @click="editDevice(device.id)" :title="$t('Edit device')" />
					<action-group-item-button @click="onDeleteDevice(device.id)" :title="$t('Delete device')" :danger="true" />
				</action-group>
			</grid-item>
			<grid-empty :showWhen="devicesByGroup(group).length === 0" :message="$t('There are no devices in this group yet.')" />
		</grid-group>
	</grid>
</template>

<script>
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
import Grid from '@/modules/ui/Grid'
import GridEmpty from '@/modules/ui/GridEmpty'
import GridItem from '@/modules/ui/GridItem'
import GridGroup from '@/modules/ui/GridGroup'
import { mapGetters } from 'vuex'
export default {
	name: 'user-watches-devices-list',
	props: [
		'user_uid'
	],
	components: {
		ActionGroup,
		ActionGroupItemButton,
		Grid,
		GridEmpty,
		GridItem,
		GridGroup
	},
	computed: {
		...mapGetters({
			currentUser: 'CURRENT_USER',
			devicesByGroup: 'DEVICES_BY_GROUP',
			devicesGroups: 'DEVICES_GROUPS',
		})
	},
	methods: {
		editGroup (group_id) {
			this.$root.$emit('editGroup', group_id)
		},
		editDevice (device_id) {
			this.$root.$emit('editDevice', device_id)
		},
		onDeleteGroup (group_id) {
			if (confirm(this.$t('buttons.general.delete') + '?')) {
				this.$api.groups.devices.delete(this, this.user_uid, group_id)
					.then(response => {
						this.$appToast.show({
							type: 'success',
							title: 'Success',
							message: 'Group deleted.'
						})
					}).catch(error => {
						this.$appToast.show({
							type: 'error',
							title: 'Error',
							message: 'Issue deleting group.'
						})
					}).finally(() => {
						this.$store.dispatch('GET_PATIENTS', this)
					})
			}
		},
		onDeleteDevice (device_id) {
			if (confirm(this.$t('buttons.general.delete') + '?')) {
				this.$api.devices.delete(this, this.user_uid, device_id)
					.then(response => {
						this.$appToast.show({
							type: 'success',
							title: 'Success',
							message: 'Device deleted.'
						})
					}).catch(error => {
						this.$appToast.show({
							type: 'error',
							title: 'Error',
							message: 'Issue deleting device.'
						})
					}).finally(() => {
						this.$store.dispatch('GET_PATIENTS', this)
					})
			}
		},
		goToPatient(device) {
			this.$router.push({
				name: 'WatchDashboard',
				params: {
					user_uid: this.currentUser.uid,
					watch_id: device.virtual_watch_id
				}
			})
		}
	},
	created() {
		this.$store.dispatch('GET_PATIENTS', this)
	}
}
</script>

<style scope>
</style>


// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesDevicesList.vue